<template>
  <OArticleCard
    ref="videoRef"
    v-bind="$attrs"
    :class="{ 'bg-[#306AFF]': isCurrent, 'bg-[#181C2E]': !isCurrent }"
    class="videoCard p-2 rounded-md"
  >
    <div class="absolute inset-0 z-2" @click="handleClick" />
    <OArticleVariant class="flex flex-col h-full">
      <OArticleCover aspect-ratio="cover" :show-video-icon="false" class="rounded-t-md">
        <div
          v-if="duration"
          class="text-sm font-medium absolute bottom-0 left-0 px-1 h-[18px] u-center rounded-bl-md rounded-tr-md bg-black-50 text-white-90"
        >
          {{ duration }}
        </div>
        <div class="u-center w-[18px] h-[18px] bg-[#306AFF] absolute right-2 top-2 rounded-full">
          <OIcon :icon="icon" />
        </div>
      </OArticleCover>
      <OArticleTitle :link="false" class="text-white text-xxs font-semibold line-clamp-3 mt-2" />
    </OArticleVariant>
  </OArticleCard>
</template>
<script>
import OArticleCard from '@/modules/card/components/ArticleCard';
import OArticleCover from '@/modules/card/components/ArticleCover';
import OArticleTitle from '@/modules/card/components/ArticleTitle';
import { computed, onUnmounted, ref } from '@nuxtjs/composition-api';
import { useInfiniteScroll } from '~/composables/useInfiniteScroll';
import OArticleVariant from '~/modules/card/components/ArticleVariant';
import { OIcon } from '~/modules/common/components/ui';
import { eventBus } from '~/modules/common/utils/eventBus';
export default {
  components: {
    OArticleCard,
    OArticleCover,
    OArticleTitle,
    OArticleVariant,
    OIcon,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    isCurrent: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const handleClick = () => {
      emit('click');
    };

    const isSentDatalayer = ref(false);
    const [videoRef] = useInfiniteScroll(() => {
      if (!isSentDatalayer.value) {
        emit('view', { item: props.item, position: props.index + 1 });
        isSentDatalayer.value = true;
      }
    });

    const isPlaying = ref(false);
    const changeStatus = (status) => {
      isPlaying.value = status;
    };

    eventBus.on('widget-player-status', changeStatus);
    onUnmounted(() => eventBus.off('widget-player-status', changeStatus));

    const icon = computed(() => (isPlaying.value && props.isCurrent ? 'pause' : 'play'));

    return { handleClick, icon, videoRef };
  },
};
</script>

<style scoped>
.videoCard {
  width: calc(100vw / 2 - 20px);
}
</style>
